module.exports = __webpack_public_path__ + "static/media/mvp.15a9b652.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mvp.png
// module id = 257
// module chunks = 0